import { FC } from 'react'

import { Select } from 'components'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled
} from './TableActions.styles'
import { EffectiveConsolidationServices } from 'services/NGT/EffectiveConsolidation'

interface TableProps {
  effectivesTableData: any[]
  listDiretoriaExecutiva: any[]
  listEmpresa: any[]
  listArea: any[]
  listUnidadeNegocio: any[]
  handleChangeDirExecutiva: (value: string, index: number) => void
  handleChangeEmpresa: (value: string, index: number) => void
  handleChangeArea: (value: string, index: number) => void
  handleChangeUniNegocio: (value: string, index: number) => void
}
export const TableActions: FC<TableProps> = ({
  effectivesTableData,
  listDiretoriaExecutiva,
  listEmpresa,
  listArea,
  listUnidadeNegocio,
  handleChangeDirExecutiva,
  handleChangeEmpresa,
  handleChangeArea,
  handleChangeUniNegocio
}) => {
  return (
    <>
      <TableContainerStyled>
        <TableStyled stickyHeader>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Unidade Gestora</TableCellStyled>
              <TableCellStyled align="left">
                Diretoria Executiva
              </TableCellStyled>
              <TableCellStyled align="left">Empresas</TableCellStyled>
              <TableCellStyled align="left">Área</TableCellStyled>
              <TableCellStyled align="left">Unidade Negócio</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {effectivesTableData?.length > 0 &&
              effectivesTableData?.map((row, index) => (
              
                
                <TableRowStyled key={index}>
                  <TableCellStyled align="left">
                    {row.nmUnidadeGestora}
                  </TableCellStyled>
                  <TableCellStyled>
                    <Select
                      valueMenu="idDiretoriaConsolidacao"
                      labelMenu="dsDiretoriaConsolidacao"
                      listOptions={listDiretoriaExecutiva}
                      value={row.diretoriaExecutivaId}
                      disabled={row.flConsolidado}
                      disableUnderline
                      marginTop="-20px"
                      onChange={(e) => {
                        const intValue = parseInt(e.target.value, 10);
                        const requestData = [{areaId: row.areaId,
                          diretoriaExecutivaId: intValue,
                          empresaId: row.empresaId,
                          flConsolidado: row.flConsolidado,
                          idConsolidacao: row.idConsolidacao,
                          nuAnoMesCompetencia: row.nuAnoMesCompetencia,
                          unidadeGestoraId: row.unidadeGestoraId,
                          unidadeNegocioId: row.unidadeNegocioId}];
                        EffectiveConsolidationServices().ConsolidacaoCreteOrUpdate(
                          requestData
                        )
                        handleChangeDirExecutiva(e.target.value, index);
                      }}
                    />
                  </TableCellStyled>
                  <TableCellStyled>
                    <Select
                      valueMenu="idEmpresaConsolidacao"
                      labelMenu="dsEmpresaConsolidacao"
                      listOptions={listEmpresa}
                      value={row.empresaId}
                      disabled={row.flConsolidado}
                      disableUnderline
                      marginTop="-20px"
                      onChange={(e) => {

                        const intValue = parseInt(e.target.value, 10);
                        const requestData = [{areaId: row.areaId,
                          diretoriaExecutivaId: row.diretoriaExecutivaId,
                          empresaId: intValue,
                          flConsolidado: row.flConsolidado,
                          idConsolidacao: row.idConsolidacao,
                          nuAnoMesCompetencia: row.nuAnoMesCompetencia,
                          unidadeGestoraId: row.unidadeGestoraId,
                          unidadeNegocioId: row.unidadeNegocioId}];
                        EffectiveConsolidationServices().ConsolidacaoCreteOrUpdate(
                          requestData
                        )
                        handleChangeEmpresa(e.target.value, index);
                      }}
                    />
                  </TableCellStyled>
                  <TableCellStyled>
                    <Select
                      valueMenu="idAreaConsolidacao"
                      labelMenu="dsAreaConsolidacao"
                      listOptions={listArea}
                      value={row.areaId}
                      disabled={row.flConsolidado}
                      disableUnderline
                      marginTop="-20px"
                      onChange={(e) => {
                        const intValue = parseInt(e.target.value, 10);
                        const requestData = [{areaId: intValue,
                          diretoriaExecutivaId: row.diretoriaExecutivaId,
                          empresaId: row.empresaId,
                          flConsolidado: row.flConsolidado,
                          idConsolidacao: row.idConsolidacao,
                          nuAnoMesCompetencia: row.nuAnoMesCompetencia,
                          unidadeGestoraId: row.unidadeGestoraId,
                          unidadeNegocioId: row.unidadeNegocioId}];
                        EffectiveConsolidationServices().ConsolidacaoCreteOrUpdate(
                          requestData
                        )
                        handleChangeArea(e.target.value, index);
                      }}
                    />
                  </TableCellStyled>
                  <TableCellStyled>
                    <Select
                      valueMenu="idUnidadeNegocioConsolidacao"
                      labelMenu="dsUnidadeNegocioConsolidacao"
                      listOptions={listUnidadeNegocio}
                      value={row.unidadeNegocioId}
                      disabled={row.flConsolidado}
                      disableUnderline
                      marginTop="-20px"
                      onChange={(e) => {
                        const intValue = parseInt(e.target.value, 10);
                        const requestData = [{areaId: row.areaId,
                          diretoriaExecutivaId: row.diretoriaExecutivaId,
                          empresaId: row.empresaId,
                          flConsolidado: row.flConsolidado,
                          idConsolidacao: row.idConsolidacao,
                          nuAnoMesCompetencia: row.nuAnoMesCompetencia,
                          unidadeGestoraId: row.unidadeGestoraId,
                          unidadeNegocioId: intValue}];
                        EffectiveConsolidationServices().ConsolidacaoCreteOrUpdate(
                          requestData
                        )
                        handleChangeUniNegocio(e.target.value, index);
                      }}
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      {/*
      <TableFooter
        page={page}
        rows={effectivesTableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
      */}
    </>
  )
}
